import _ from 'lodash'


const getProgramDetailsEventFlagValue = (programDetailsData,keyName,returnBoolean)  => {
    let defaultSearchKey = 'feature_flags.event_feature_config.DEFAULT.' + keyName
    let SearchKey = 'feature_flags.' + keyName 
    
    
    const searchValue = _.get(programDetailsData,
          defaultSearchKey, 
          _.get(programDetailsData,
                SearchKey,
                false
               )
          )  ? true : false
    if(returnBoolean)
    {
      return searchValue
    }
    else{
      return searchValue? 'Enabled':'Disabled'
    }
  }

export {getProgramDetailsEventFlagValue}